<!-- Overlay de fundo escuro -->
<div 
  *ngIf="isVisible" 
  class="tour-overlay"
  [class.has-highlight]="highlightRect"
>
  <!-- Área de destaque (buraco no overlay) -->
  <div 
    *ngIf="highlightRect && !isLoading" 
    class="tour-highlight-area"
    [style.top.px]="highlightRect.top - 8"
    [style.left.px]="highlightRect.left - 8"
    [style.width.px]="highlightRect.width + 16"
    [style.height.px]="highlightRect.height + 16"
  ></div>
</div>

<!-- Tooltip/Card do Tour -->
<div 
  *ngIf="isVisible && !isLoading" 
  class="tour-tooltip"
  [class.is-centered]="!highlightRect"
  [style.top.px]="tooltipPosition.top"
  [style.left.px]="tooltipPosition.left"
>
  <!-- Seta indicadora -->
  <div 
    *ngIf="highlightRect" 
    class="tour-arrow"
    [class.arrow-top]="arrowDirection === 'top'"
    [class.arrow-bottom]="arrowDirection === 'bottom'"
    [class.arrow-left]="arrowDirection === 'left'"
    [class.arrow-right]="arrowDirection === 'right'"
  ></div>

  <!-- Header do tooltip -->
  <div class="tour-header">
    <div class="tour-step-indicator">
      Passo {{ currentStepIndex + 1 }} de {{ steps.length }}
    </div>
    <button 
      mat-icon-button 
      class="tour-close-btn"
      (click)="closeTour()"
      matTooltip="Pular guia"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Conteúdo -->
  <div class="tour-content">
    <h3 class="tour-title">{{ currentStep.title }}</h3>
    <p class="tour-description">{{ currentStep.description }}</p>
  </div>

  <!-- Barra de progresso -->
  <div class="tour-progress">
    <div class="tour-progress-bar" [style.width.%]="progressPercent"></div>
  </div>

  <!-- Ações -->
  <div class="tour-actions">
    <button 
      mat-button 
      class="tour-skip-btn"
      (click)="skipTour()"
    >
      Pular Guia
    </button>
    
    <div class="tour-nav-buttons">
      <button 
        *ngIf="!isFirstStep"
        mat-stroked-button 
        class="tour-prev-btn"
        (click)="previousStep()"
      >
        <mat-icon>arrow_back</mat-icon>
        Anterior
      </button>
      
      <button 
        mat-flat-button 
        class="tour-next-btn"
        (click)="nextStep()"
      >
        {{ isLastStep ? 'Concluir' : 'Próximo' }}
        <mat-icon *ngIf="!isLastStep">arrow_forward</mat-icon>
        <mat-icon *ngIf="isLastStep">check</mat-icon>
      </button>
    </div>
  </div>
</div>
